import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { PersonRelationshipViewModel } from '../../../models/Entities/Person/Relationship/PersonRelationshipModels';

// store
import * as PersonRelationshipsStore from '../../../redux/middleware/PersonRelationships.Middleware';

export interface IProps {
  PersonId: number;
  PersonType?: number | undefined;
}

interface ConnectedProps {
  isLoading: boolean | undefined;
  isLoadingSuccessfully: boolean | undefined;
  failOnLoading: boolean | undefined;
  isDeleting: boolean | undefined;
  failOnDeleting: boolean | undefined;
  error: ErrorType | undefined;
  relationships: PersonRelationshipViewModel[];
}

interface DispatchProps {
  GetPersonRelationships: typeof PersonRelationshipsStore.actionCreators.GetPersonRelationships;
  DeletePersonRelationship: typeof PersonRelationshipsStore.actionCreators.DeletePersonRelationship;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isLoading: state.PersonRelationships?.isLoadingAll,
  isLoadingSuccessfully: state.PersonRelationships?.successLoadingAll,
  failOnLoading: state.PersonRelationships?.failOnLoadingAll,
  isDeleting: state.PersonRelationships?.isDeletingOne,
  failOnDeleting: state.PersonRelationships?.failOnDeletingOne,
  error: state.PersonRelationships?.error,
  relationships: (state.PersonRelationships?.list ?? []).filter(
    (item: PersonRelationshipViewModel) => item.personId === ownProps.PersonId && !item.isDeleted
  ),
  ...ownProps
});

export const mapDispatchToProps = {
  ...PersonRelationshipsStore.actionCreators
};
